// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__JXsTW","boxTitle":"Qualiphy_boxTitle__2Duas","box":"Qualiphy_box__1M1IV","toggleWrap":"Qualiphy_toggleWrap__3fl7L"};